import { ansichtAusDom } from "./ansichtErfassen";
import { alleDokumente } from "../windowManager/browserFenster/fensterRegister";

/**
 * Seitenverlauf fürs Melden: Wer ein Problem erst bemerkt und dann vom
 * Dashboard aus meldet, hinterlässt sonst nur „/“ (PROD-Ticket T-2). Darum
 * merkt sich der Browser laufend die letzten Stationen — Route plus Fenster/
 * Tab (ansichtAusDom), NUR Orte, keine Inhalte — und schickt sie erst beim
 * Melden mit (technik.verlauf, sichtbar nur für Admin/GF-GL und Claude).
 */
export type Station = { zeit: string; route: string; ansicht: string | null };

export const VERLAUF_MAX = 15;
const MAX_ROUTE = 500;
const MAX_ANSICHT = 300;

let stationen: Station[] = [];

/** Neue Station anhängen — unverändert gegenüber der letzten zählt nicht. */
export function merkeStation(route: string, ansicht: string | null, jetzt: Date = new Date()): void {
  const r = String(route || "/").slice(0, MAX_ROUTE);
  const a = ansicht ? ansicht.slice(0, MAX_ANSICHT) : null;
  const letzte = stationen[stationen.length - 1];
  if (letzte && letzte.route === r && letzte.ansicht === a) return;
  stationen.push({ zeit: jetzt.toISOString(), route: r, ansicht: a });
  if (stationen.length > VERLAUF_MAX) stationen = stationen.slice(-VERLAUF_MAX);
}

export function verlaufSchnappschuss(): Station[] {
  return stationen.map((s) => ({ ...s }));
}

export function _verlaufLeeren(): void {
  stationen = [];
}

/** Aktuellen Ort aus URL und DOM ablesen und merken. */
export function erfasseStation(): void {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  merkeStation(window.location.pathname + window.location.search, ansichtAusDom(document.body));
}

/** Nach Klicks erneut ablesen — Tabs und Fenster ändern die URL nicht. */
const NACH_KLICK_MS = 400;

export function beobachteKlicks(): () => void {
  let timer: number | undefined;
  const klick = (e: Event) => {
    const ziel = e.target as Element | null;
    // Melden-Knopf, Dialog, Aufnahme: kein Ort, an dem gearbeitet wurde.
    if (ziel && typeof ziel.closest === "function" && ziel.closest("[data-ticket-ignore]")) return;
    window.clearTimeout(timer);
    timer = window.setTimeout(erfasseStation, NACH_KLICK_MS);
  };
  alleDokumente.addEventListener("click", klick, true);
  return () => {
    window.clearTimeout(timer);
    alleDokumente.removeEventListener("click", klick, true);
  };
}
